import { TimeZone } from './timeZone';

export enum ThemePreference {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM',
}

export type SettingsItems = {
  preferences: Preferences;
  pushNotifications: PushNotificationSetting[];
};

export type Preferences = {
  themePreference: ThemePreference;
  timeZone: TimeZone;
};

export type PushNotificationSetting = {
  isEnabled: boolean;
  isUpdating?: boolean;
  key:
    | 'SMART_ACTIONS'
    | 'SYSTEM_MESSAGES'
    | 'MENTIONS'
    | 'USERS'
    | 'CUSTOM_CHANNEL_SMART_ACTIONS'
    | 'CUSTOM_CHANNEL_SYSTEM_MESSAGES'
    | 'CUSTOM_CHANNEL_MENTIONS'
    | 'CUSTOM_CHANNEL_USERS';
};

export const PUSH_NOTIFICATION_GROUPS_IN_ORDER = ['MAIN_ROOM', 'CUSTOM_CHANNELS'] as const;

export type PushNotificationGroup = (typeof PUSH_NOTIFICATION_GROUPS_IN_ORDER)[number];

export type PushNotificationGroupState = 'ON' | 'OFF' | 'CUSTOM';
